import React, { FunctionComponent, useMemo } from 'react';
import { CURRENT_DATE } from '../../../../../../../app/resource/calendar/calendar.types';
import { getDaysOfMonth } from '../../../../../../../utils/date.utils';
import { CalendarItemDay } from './CalendarItemDay';
import { IMonthViewProps } from './types';
import moment from 'moment';

export const MonthView: FunctionComponent<IMonthViewProps> = ({ date, meetingId, userFilter }) => {
  const daysOfMonth = useMemo(() => {
    return getDaysOfMonth(date);
  }, [date]);

  // get the day of the week of the 1st of the month
  const firstDayOfTheWeekIndex = useMemo(() => {
    return parseInt(moment(daysOfMonth[0]).format('d'));
  }, [daysOfMonth]);

  /**
   * Render the day boxes that would be the placeholders in case the month
   * does not start on sunday
   * @returns
   */
  function renderWeekDaysPlaceholder() {
    const placeholderDays: React.ReactNode[] = [];
    for (let d = 0; d < firstDayOfTheWeekIndex; d++) {
      placeholderDays.push(
        <div key={`date-placeholder-${d}`} className="calendar-cell">
          <span className={`calendar-cell-day`}></span>
        </div>,
      );
    }

    return placeholderDays;
  }

  return (
    <>
      <div className="calendar-rendered">
        <div className="calendar-days">
          <div className="calendar-cell">
            <div className="calendar-cell-day">SUN</div>
          </div>
          <div className="calendar-cell">
            <div className="calendar-cell-day">MON</div>
          </div>
          <div className="calendar-cell">
            <div className="calendar-cell-day">TUE</div>
          </div>
          <div className="calendar-cell">
            <div className="calendar-cell-day">WED</div>
          </div>
          <div className="calendar-cell">
            <div className="calendar-cell-day">THU</div>
          </div>
          <div className="calendar-cell">
            <div className="calendar-cell-day">FRI</div>
          </div>
          <div className="calendar-cell">
            <div className="calendar-cell-day">SAT</div>
          </div>
        </div>
        {renderWeekDaysPlaceholder()}
        {daysOfMonth.map((date, index) => (
          <div key={`date-${date}`} className="calendar-cell">
            <span className={`calendar-cell-day ${CURRENT_DATE === date ? 'today' : ''}`}>{index + 1}</span>
            <CalendarItemDay meetingId={meetingId} date={date} userFilter={userFilter} />
          </div>
        ))}
      </div>
    </>
  );
};
